import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BusinessLoansCreateFormFields } from "web_myplann/Portfolio/Forms/BusinessLoansForm/BusinessLoansCreateFormFields";
import { useCreateBusinessLoansForm } from "web_myplann/Portfolio/Forms/BusinessLoansForm/useCreateBusinessLoansForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateBusinessLoansForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateBusinessLoansForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<BusinessLoansCreateFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
